var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.apiKey)?_c('v-app',{staticStyle:{"position":"absolute","width":"100vw","height":"100vh"}},[_c('v-main',{staticClass:"Kanit",attrs:{"id":"webchat"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"beforeLeave":_vm.beforeLeave,"enter":_vm.enter,"afterEnter":_vm.afterEnter}},[(_vm.loading)?void 0:_c('Main')],2)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }